export default __webpack_public_path__ + "static/media/a6.e9a0b708.jpg";